import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import printPartialPage from "@MasterBluePrint/Overrides/Common/Utilities/openPrintDialog";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";

interface OwnProps {
    paymentMethod: any;
    BankName:string;
    BankAddress:string;
    BankPhone:string;
    BankContactName:string;
    BankContactEmail:string;
    BankAccountName:string;
    BankAccountNumber:string;
    BankSwift:string;
    BankARBRounting:string;
    BankCurrency:string;
    TaxIDNumber:string;
    AccountReceivableContactName:string;
    AccountReceivableContactPhone:string;
    AccountReceivableContactEmail:string;
    AccountReceivableContactACHEmailRemittance:string;    
}
export interface WirePaymentEntryStyles {
    wirePaymentGridcontainer?: GridContainerProps;
    wireTitleContainer?: InjectableCss;
    wirePaymentDetails?: GridItemProps;
    wirePaymentWarningMessage?: InjectableCss;
    wirePaymentInfoContainer?: GridContainerProps;
    wirePaymentInfoLeftPart?: GridItemProps;
    wirePaymentHeadingAndText?: InjectableCss;
    wirePaymentText?: SmallHeadingAndTextStyles;
    wirePaymentInfoRightPart?: GridItemProps;
    wireTaxDetails?: GridItemProps;
    wireAccountReceiveDetails?: GridItemProps;
    wireAccountReceivableContactDetails?: InjectableCss;
    accountReceivableContactContainer?: GridContainerProps;
    accountReceivablePhone?: GridItemProps;
    accountReceivableEmail?: GridItemProps;
    accountReceivableOther?: GridItemProps;
    printButton?: ButtonPresentationProps;
}

export const wirePaymentEntryStyles: WirePaymentEntryStyles = {
    wirePaymentGridcontainer: {
        gap: 10,
    },
    wireTitleContainer:{
        css: css`
            width: 100%;
            display: inline-flex;
        `,
    },
    wirePaymentDetails: {
        width: 12,
        css: css`
            padding: 10px 0;
            border-top: 1px solid #C2D1D9;
            border-bottom: 1px solid #C2D1D9;
            flex-direction: column;
        `,
    },
    wirePaymentWarningMessage: {
        css: css`
            width: 100%;
            border: 1px solid #FFDEB2;
            border-radius: 2px;
            background-color: #FFEFD9;
            padding: 10px;

            > span {
                color: #2E384D;
                font-family: Lato;
                font-size: 16px;
                letter-spacing: 0;
                line-height: 24px;
            }
        `,
    },
    wirePaymentInfoContainer: {
        css: css`
            padding: 20px 0 10px;
        `,
    },
    wirePaymentInfoLeftPart: {
        width: [12,12,12,7,7],
        css: css`
            .wire-payment-info {
                width: 100%;

                p[data-test-selector="heading"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #002554;
                    font-family: 'Roboto',sans-serif;
                    text-transform: capitalize;
                }
                p[data-test-selector="text"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0.18px;
                    color: #2E384D;
                    font-family: 'Lato',sans-serif;
                }
                .wirepayment-bank-info-address {
                    display: block;
                    p[data-test-selector="text"] {
                        width: 200px;
                    }
                }
                .wirepayment-bank-info-phone {
                    display: block;
                    border-bottom: 1px solid #C2D1D9;
                }
                .wirepayment-bank-info-contact {
                    padding: 10px 20px 20px 30px;
                    display: block;

                    div:first-child {
                        p[data-test-selector="text"] {
                            color: #002554;
                            font-family: 'Lato',sans-serif;
                            font-size: 18px;
                            font-weight: bold;
                            letter-spacing: 0;
                            line-height: 22px;
                        }
                    }

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                padding: 0;
                            `,
                        ],
                        "max",
                    )}
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        padding-bottom: 0;
                    `,
                ],
                "max",
            )}
        `,
    },
    wirePaymentHeadingAndText: {
        css: css`
            margin-bottom: 15px;
        `,
    },
	wirePaymentInfoRightPart: {
        width: [12,12,12,5,5],
        css: css`
            .wirepayment-bank-account-details {
                width: 100%;
                display: block;
                box-sizing: border-box;
                border: 1px solid #C3D4EA;
                border-radius: 2px;
                background: #F7F9FA;
                padding: 20px;

                p[data-test-selector="heading"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0;
                    color: #002554;
                    font-family: 'Roboto',sans-serif;
                    text-transform: capitalize;
                }
                p[data-test-selector="text"] {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    letter-spacing: 0.18px;
                    color: #2E384D;
                    font-family: 'Lato',sans-serif;
                }
                .wirepayment-account-info,
                .wire-account-information,
                .wire-account-info {
                    p[data-test-selector="text"] { 
                        font-size: 18px;
                        letter-spacing: 0.21px;
                    }
                }
            }
        `,
    },
    wireTaxDetails: {
        width: 12,
        css: css`
            font-size: 18px;
            letter-spacing: 0;
            border-bottom: 1px solid #C2D1D9;
            padding: 10px 0;
            align-items: center;
            
            .wire-tax-label {
                color: #2060AD;
                font-family: 'Roboto',sans-serif;                
                font-weight: 500;                
                line-height: 23px;
            }
            .wire-tax-value {
                color: #333F48;
                font-family: 'Lato',sans-serif;
                font-weight: bold;
                line-height: 30px;
                padding-left: 20px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        align-items: flex-start;
                        flex-direction: column;

                        .wire-tax-value {
                            padding-left: 0;
                        }
                    `,
                ],
                "max",
            )}
        `,
    },
    wireAccountReceiveDetails: {
        width: 12,
        css: css`
        padding: 0;
            flex-direction: column;

            div[data-test-selector="accountReceiveHeading"] {
                border-bottom: 1px solid #C2D1D9;
                padding: 15px 0 12px;

                .wire-heading {
                    margin: 0;
                }
            }
            span[data-test-selector="wirePaymentReceivableMsg"] {
                margin: 10px 0;
            }
        `,
    },
    wireAccountReceivableContactDetails: {
        css: css`
            width: 100%;
            display: block;
            border: 1px solid #C3D4EA;
            border-radius: 2px;
            background: #F7F9FA;
            padding: 20px;

            .receivable-name {
                padding-bottom: 10px;
                display: block;
                color: #002554;
                font-family: 'Lato',sans-serif;
                font-size: 18px;
                font-weight: bold;
                letter-spacing: 0;
                line-height: 22px;
            }
        `,
    },
    accountReceivableContactContainer: {
        gap: 10,
        css: css`
            p[data-test-selector="heading"] {
                color: #002554;
                font-family: 'Roboto',sans-serif;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 30px;
                text-transform: capitalize;
            }
            p[data-test-selector="text"] {
                color: #2E384D;
                font-family: 'Lato',sans-serif;
                font-size: 16px;
                letter-spacing: 0.18px;
                line-height: 30px;
            }

            .account-receivable-phone {
                p[data-test-selector="text"] {
                    font-size: 18px;
                    letter-spacing: 0.21px;
                }
            }

            .account-receivable-phone,
            .account-receivable-email,
            .account-receivable-other {
                div:first-child {
                    margin-bottom: 0;

                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-bottom: 5px;
                            `,
                        ],
                        "max",
                    )}
                }
            }
        `,
    },
    accountReceivablePhone: {
        width: [12,12,12,4,4],
        css: css`
            p[data-test-selector="text"] {
                font-size: 18px;
                letter-spacing: 0.21px;
            }
        `,
    },
    accountReceivableEmail: {
        width: [12,12,12,4,4],
        css: css`
            
        `,
    },
    accountReceivableOther: {
        width: [12,12,12,4,4],
        css: css`
            
        `,
    },
    printButton: {
        buttonType: "outline",
        variant: "secondary",
        css: css`
            border: none;
            background: none;
            padding: 0;
            color: #002554;
            font-family: Lato;
            font-size: 14px;
            letter-spacing: 0.16px;
            line-height: 18px;
            float: right;
            height: auto;
            margin-left: 15px;
            margin-right: 15px;
            margin-top:5px;
            border-left: 1px solid #C2D1D9;
            height: 20px;
            padding-left: 15px;

            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        display: flex;
                        margin: 0 5px;
                        align-items: center;
                        align-content: center;
                        display: none;
                    }
                    `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};

            span {
                display: inline-block;
                vertical-align: middle;

                &:last-child {
                    margin-left: 5px;
                    color: #002554;
                    font-family: Lato;
                    font-size: 14px;
                    letter-spacing: 0.16px;
                    line-height: 18px;
                }

                ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                // max-width:70px;
                            `,
                        null,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )};
            }

            svg {
                display: inline-block;
                vertical-align: middle;
                font-size: 14px;
                color: #002554;
                width: 21px;
                height: 20px;
            }
            &:hover,
            &:active,
            &:focus {
                color: #002554 !important;
                border: none !important;
                background: none !important;
                padding: 0;
                border-left: 1px solid #C2D1D9 !important;
                height: 20px;
                padding-left: 15px;
            }
           
            .btn-wrapper {
                a,
                button {
                    &:before {
                        content: "";
                        display: inline-block;
                        border-left: 1px solid #e4e8f0;
                        height: 14px;
                        margin: 0 10px;
                        position: relative;
                        left: -10px;
                        top: 2px;
                    }
                }

        `,
    },
};

const styles = wirePaymentEntryStyles;

const mapStateToProps = (state: ApplicationState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    return {
        cartState,
        session: state.context.session,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const WirePaymentEntry: FC<Props> = ({paymentMethod,
    BankName,
    BankAddress,
    BankPhone,
    BankContactName,
    BankContactEmail,
    BankAccountName,
    BankAccountNumber,
    BankSwift,
    BankARBRounting,
    BankCurrency,
    TaxIDNumber,
    AccountReceivableContactName,
    AccountReceivableContactPhone,
    AccountReceivableContactEmail,
    AccountReceivableContactACHEmailRemittance,
}) =>{
    const featureFlags: string[] = ["TEUS-7841"];
    const flagValues = useLaunchDarklyFlags({ featureFlags });
    const showPrintWireInstructionsButtton = flagValues["TEUS-7841"];

    return (
        <GridContainer {...styles.wirePaymentGridcontainer} id="wirePaymentContainer">
            <Typography {...styles.wireTitleContainer} as="div">
                <h3 className="wire-heading">{translate("Wire Transfers Bank Information")}</h3>
                { 
                    showPrintWireInstructionsButtton 
                    && 
                    <Button {...styles.printButton} className="btn-wrapper print-hide-items" onClick={(e:any)=>{
                        e.preventDefault();
                        printPartialPage()
                    }}>
                        <Icon src="Printer" />
                        <span>{translate("Print Wire Instructions")}</span>
                    </Button>
                }
            </Typography>
            <GridItem {...styles.wirePaymentDetails} id="wire-payment-details">
                <Typography {...styles.wirePaymentWarningMessage} className="info-message">
                    {translate(
                        "Please reference the invoice number on all transactions to ensure prompt payment of invoices.",
                    )}
                </Typography>
                <GridContainer {...styles.wirePaymentInfoContainer} data-test-selector="wirePaymentInfoContainer">
                    <GridItem {...styles.wirePaymentInfoLeftPart} className="print-wire-payment-info">
                        <Typography as="div" className="wire-payment-info">
                            <SmallHeadingAndText
                                heading={translate("Bank Name")}
                                text={translate(BankName)}
                                extendedStyles={styles.wirePaymentText}
                                {...styles.wirePaymentHeadingAndText}
                            />
                            <Typography className="wirepayment-bank-info-address">
                                <SmallHeadingAndText
                                    heading={translate("Bank Address")}
                                    text={translate(BankAddress)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>

                            <Typography className="wirepayment-bank-info-phone">
                                <SmallHeadingAndText
                                    heading={translate("Bank Phone")}
                                    text={translate(BankPhone)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>

                            <Typography className="wirepayment-bank-info-contact">
                                <SmallHeadingAndText
                                    heading={translate("Bank Contact")}
                                    text={translate(BankContactName)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                                <SmallHeadingAndText
                                    heading={translate("Email")}
                                    text={translate(BankContactEmail)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.wirePaymentInfoRightPart} className="print-wirepayment-bank-account-details">
                        <Typography className="wirepayment-bank-account-details">
                            <SmallHeadingAndText
                                heading={translate("Bank Account Name")}
                                text={translate(BankAccountName)}
                                extendedStyles={styles.wirePaymentText}
                                {...styles.wirePaymentHeadingAndText}
                            />
                            <Typography className="wirepayment-account-info">
                                <SmallHeadingAndText
                                    heading={translate("Bank Account Number")}
                                    text={translate(BankAccountNumber)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>
                            <Typography className="wire-account-information">
                                <SmallHeadingAndText
                                    heading={translate("SWIFT")}
                                    text={translate(BankSwift)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>
                            <Typography className="wire-account-info">
                                <SmallHeadingAndText
                                    heading={translate("ABA/Routing#")}
                                    text={translate(BankARBRounting)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>
                            <Typography className="wire-account-currency-info">
                                <SmallHeadingAndText
                                    heading={translate("Currency")}
                                    text={translate(BankCurrency)}
                                    extendedStyles={styles.wirePaymentText}
                                    {...styles.wirePaymentHeadingAndText}
                                />
                            </Typography>
                        </Typography>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.wireTaxDetails} data-test-selector="wire-tax-details">
                <Typography className="wire-tax-label">{translate("TESTEQUITY Tax ID Number")}</Typography>
                <Typography className="wire-tax-value">{translate(TaxIDNumber)}</Typography>
            </GridItem>
            <GridItem {...styles.wireAccountReceiveDetails} data-test-selector="wire-account-receive-details">
                <Typography {...styles.wireTitleContainer} as="div" data-test-selector="accountReceiveHeading">
                    <h3 className="wire-heading">{translate("Accounts Receivable Contact")}</h3>
                </Typography>
                <Typography
                    {...styles.wirePaymentWarningMessage}
                    data-test-selector="wirePaymentReceivableMsg"
                    className="info-message"
                >
                    {translate("Please include company name and dollar amount in subject line.")}
                </Typography>
                <StyledTypography
                    as="div"
                    {...styles.wireAccountReceivableContactDetails}
                    data-test-selector="wire-account-receive-detail"
                >
                    <Typography className="receivable-name">{translate(AccountReceivableContactName)}</Typography>
                    <GridContainer {...styles.accountReceivableContactContainer}>
                        <GridItem {...styles.accountReceivablePhone} className="account-receivable-phone">
                            <SmallHeadingAndText
                                heading={translate("Phone")}
                                text={translate(AccountReceivableContactPhone)}
                                extendedStyles={styles.wirePaymentText}
                                {...styles.wirePaymentHeadingAndText}
                            />
                        </GridItem>
                        <GridItem {...styles.accountReceivableEmail} className="account-receivable-email">
                            <SmallHeadingAndText
                                heading={translate("Email")}
                                text={translate(AccountReceivableContactEmail)}
                                extendedStyles={styles.wirePaymentText}
                                {...styles.wirePaymentHeadingAndText}
                            />
                        </GridItem>
                        <GridItem {...styles.accountReceivableOther} className="account-receivable-other">
                            <SmallHeadingAndText
                                heading={translate("ACH Email Remittance")}
                                text={translate(AccountReceivableContactACHEmailRemittance)}
                                extendedStyles={styles.wirePaymentText}
                                {...styles.wirePaymentHeadingAndText}
                            />
                        </GridItem>
                    </GridContainer>
                </StyledTypography>
            </GridItem>
        </GridContainer>
    );
};

// const widgetModule: WidgetModule = {
//     component: connect(mapStateToProps)(WirePaymentEntry),
//     definition: {
//         group: "Common",
//         displayName: "Wire Payment Widget",
//         // allowedContexts: ["RfqMyQuotesPage"],
//     },
// };

// export default widgetModule;
export default connect(mapStateToProps)(WirePaymentEntry);
